module.exports = __webpack_public_path__ + "static/media/Lock.c45ba74f.svg";